import React from "react";
import { Container } from "react-bootstrap";
import "./Map_View.css"
import CommonHeading from "../../Common_Components/Common_Heading/Common_Heading";

const Map_View = () => {
  return (
    <section className="Map_View">
      <Container>
        <CommonHeading title="Find Us on Map" />

        {/* Map */}
        <div className="Map_Section__map">
          <iframe
            title="Find Us on Map"
            src="https://www.google.com/maps?q=Deoria,+Uttar+Pradesh,+India&output=embed"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          ></iframe>
        </div>
      </Container>
    </section>
  );
};

export default Map_View;
